var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.63 55.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Internet",
    className: "cls-1",
    d: "M67.26,27.73c.27-1.13.41-2.31.41-3.53,0-7.81-5.81-14.14-12.95-14.14-2.89,0-5.57,1.05-7.74,2.81C44.27,4.88,37.05-.54,28.93.04,18.93.78,11.33,10.3,11.96,21.34c.08,1.67.37,3.26.78,4.75C5.65,26.41-.01,32.78,0,40.58,0,48.6,5.94,55.09,13.27,55.09h52.22c6.69,0,12.14-6.16,12.14-13.76,0-6.91-4.49-12.63-10.36-13.61ZM49.18,36.3c-1.05,0-1.98-.51-2.58-1.28l-5.19-5.19s.01,14.34.01,14.46c0,1.85-1.5,3.35-3.35,3.35h0s0,0,0,0c-1.85,0-3.35-1.5-3.35-3.35,0-.12.01-14.46.01-14.46l-5.19,5.19c-.6.77-1.53,1.28-2.58,1.28-1.81,0-3.28-1.47-3.28-3.28,0-.75.26-1.42.68-1.98.01-.02,13.31-13.34,13.31-13.34.11-.11.25-.16.4-.16,0,0,0,0,0,0h0c.14,0,.29.05.4.16,0,0,13.3,13.32,13.31,13.34.42.55.68,1.23.68,1.98,0,1.81-1.47,3.28-3.28,3.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.22319ac728939bbb9ae23f41fd491452.svg";
export { ForwardRef as ReactComponent };